<template>
    <v-layout justify-center>
        <v-flex>
            <v-layout wrap>
                <v-flex v-for="card in cards" :key="card.name" d-flex xs12 sm12 md6 lg6 xl6 class="box-flex">
                    <v-card class="mx-auto" height="100%">
                        <v-card-title>
                            <span class="category-headline-text" v-text="card.name"></span>
                        </v-card-title>
                        <v-layout wrap>
                            <v-flex d-flex pa-2 xs12 sm6 md6 lg6>
                                <UploadImage :images="card.images" :isEditable="isEditable"/>
                            </v-flex>
                            <v-flex d-flex pa-2 xs12 sm6 md6 lg6>
                                <div class="wrap-view-3d">
                                    <Viewer3d class="mesh-sample-viewer" :mesh="card.meshUrl"/>
                                    <p>Drag to spin model</p>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
    import UploadImage from "../components/UploadImage.vue";
    import Viewer3d from "../components/Viewer3d.vue";

    export default {
        props: ['cards', 'isEditable'],
        components: {
            UploadImage,
            Viewer3d
        },
        data() {
            return {}
        },
    }
</script>
<style scoped>

    .box-flex{
        padding-right: 1rem;
        margin-bottom: 1rem;
    }
    .box-flex:nth-child(2n){
        padding-right: 0;
    }

    #my-strictly-unique-vue-upload-multiple-image {
        margin: 5px 0;
    }

    .mesh-sample-viewer {
        margin: 0 !important;
        padding: 4px 4px 1px 4px !important;
        width: 100% !important;
        height: 90% !important;
        border-bottom: 5px lightgrey inset;
        border-radius: 2px;
    }
    .wrap-view-3d{
        padding: 5px;
    }
    .wrap-view-3d p{
        padding-top: 2px;
    }
    @media only screen and (max-width: 640px) {
        .box-flex{
            padding-right: 0;
        }
    }
</style>
